<div class="panel">
	<div class="panel-body-tight">
		<div class="mapper-grid-scroll-shell">
		<dx-data-grid [dataSource]="mappingRows" [showBorders]="false" [columnAutoWidth]="false" [allowColumnResizing]="true" columnResizingMode="widget" [rowAlternationEnabled]="false" [hoverStateEnabled]="true" [wordWrapEnabled]="true" [width]="'100%'" [height]="'100%'" [paging]="gridPaging" [focusedRowEnabled]="false"
			[sorting]="gridSorting" keyExpr="targetFieldId" (onRowClick)="onRowClick($event)" (onFocusedRowChanged)="onFocusedRowChanged($event)" (onCellPrepared)="onCellPrepared($event)" (onContentReady)="onGridContentReady()" (onOptionChanged)="onGridOptionChanged($event)">

			<dxo-scrolling mode="standard" [useNative]="true" [scrollByContent]="true" [scrollByThumb]="true" showScrollbar="onHover"></dxo-scrolling>
			<dxo-keyboard-navigation [enabled]="false"></dxo-keyboard-navigation>
			<dxo-search-panel [visible]="false"></dxo-search-panel>
			<dxo-column-chooser [enabled]="false"></dxo-column-chooser>
			<dxo-export [enabled]="false"></dxo-export>

			<dxi-column name="linkKey" [width]="112" alignment="center" cellTemplate="keyTemplate" headerCellTemplate="keyHeaderTemplate">
			</dxi-column>

			<dxi-column name="field" [caption]="'Field (' + targetSystemName + ')'" [minWidth]="200" cellTemplate="fieldTemplate">
			</dxi-column>

			<dxi-column name="mode" dataField="mode" caption="Mode" [width]="160" cellTemplate="modeTemplate">
			</dxi-column>

			<dxi-column name="mapping" [caption]="'Mapping (' + sourceSystemName + ' to ' + targetSystemName + ')'" [width]="330" [minWidth]="280" cellTemplate="valueTemplate">
			</dxi-column>

			<dxi-column name="preview" [caption]="'Preview (' + targetSystemName + ')'" [minWidth]="200" cellTemplate="previewTemplate">
			</dxi-column>

			<dxi-column name="status" caption="Status" [width]="170" cellTemplate="statusTemplate">
			</dxi-column>

			<div *dxTemplate="let cell of 'keyHeaderTemplate'">
				<div class="key-header" title="One shared key is used for create and update. Map the row first, then select a direct source field as the record link key.">
					<span>Key</span>
					<small>Map first</small>
				</div>
			</div>

			<div *dxTemplate="let cell of 'keyTemplate'">
				<div class="key-cell">
					<label class="field-key-toggle" [attr.title]="getLinkKeyTooltip(cell.data)" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
						<input type="checkbox" [checked]="cell.data.isLinkKey" [disabled]="!canUseAsLinkKey(cell.data)" (change)="onLinkKeyChanged(cell.data, $event)" />
					</label>
					<span *ngIf="cell.data.isLinkKey && cell.data.matchOnlyLinkKey" class="match-only-key-badge" title="Match-only key: used to find the target record, but never written to the target">
						<span class="match-only-key-icon" aria-hidden="true"></span>
						<span>Match only</span>
					</span>
				</div>
			</div>

			<div *dxTemplate="let cell of 'fieldTemplate'">
				<div class="field-cell" [attr.data-cy]="'mapper-row-field-' + cell.data.targetFieldId" [attr.data-mapper-row-id]="cell.data.targetFieldId" [ngClass]="[
            'state-' + getRowState(cell.data),
            cell.data.targetFieldId === selectedRowId ? 'is-selected' : ''
          ]">
					<div class="field-title-row" [attr.title]="cell.data.description || cell.data.targetPath || null">
						<div class="field-title-wrap">
							<div class="field-title-block">
								<div class="field-title">{{ getFieldTitle(cell.data) }}</div>
								<div class="field-path-context" *ngIf="getFieldPathContext(cell.data) as pathContext">{{ pathContext }}</div>
							</div>
							<div class="field-info-trigger" tabindex="0" role="button" aria-label="Show field details" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
								<span class="field-info-trigger-icon">i</span>
								<div class="field-info-popover" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
									<div class="field-info-popover-title">{{ getFieldInfoTitle(cell.data) }}</div>
									<div class="field-info-popover-copy">{{ getFieldInfoDescription(cell.data) }}</div>
									<div class="field-info-popover-grid">
										<div class="field-info-item">
											<span>Type</span>
											<strong>{{ cell.data.targetDataType }}</strong>
										</div>
										<div class="field-info-item">
											<span>Mode</span>
											<strong>{{ cell.data.mode }}</strong>
										</div>
										<div class="field-info-item">
											<span>{{ cell.data.mode === 'Lookup' ? 'Lookup' : 'Source' }}</span>
											<strong>{{ getFieldInfoSourceSummary(cell.data) }}</strong>
										</div>
										<div class="field-info-item">
											<span>Preview</span>
											<strong>{{ formatFieldInfoPreviewValue(cell.data.previewValue) }}</strong>
										</div>
										<div class="field-info-item">
											<span>Record link key</span>
											<strong>{{ getFieldInfoLinkKeyLabel(cell.data) }}</strong>
										</div>
										<div class="field-info-item field-info-item-wide" *ngIf="getMetadataSummary(cell.data) as metadataSummary">
											<span>Details</span>
											<strong>{{ metadataSummary }}</strong>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="field-markers">
							<span class="field-marker required" *ngIf="cell.data.required" title="Required"></span>
							<span class="field-marker match-only-link-key" *ngIf="cell.data.isLinkKey && cell.data.matchOnlyLinkKey" title="Non-standard match-only key: used to find the target record, but never written to the target"></span>
							<span class="field-marker link-key" *ngIf="cell.data.isLinkKey && !cell.data.matchOnlyLinkKey" title="Used as record link key"></span>
							<span class="field-marker reference" *ngIf="cell.data.isReference" title="Resolved through a related object"></span>
							<span class="field-marker picklist" *ngIf="cell.data.isPicklist" title="Picklist field"></span>
							<span class="field-marker readonly" *ngIf="cell.data.readOnly && !(cell.data.isLinkKey && cell.data.matchOnlyLinkKey)" [attr.title]="cell.data.matchOnlyLinkKey ? 'Read-only target; available for record matching only' : 'Read-only'"></span>
						</div>
					</div>
				</div>
			</div>

			<div *dxTemplate="let cell of 'modeTemplate'">
				<div class="mode-cell" [attr.data-cy]="'mapper-mode-editor-' + cell.data.targetFieldId" (mapper-set-mode)="selectModeFromEvent($event, cell.data)">
					<ng-container *ngIf="isChildMappingRow(cell.data); else rowModeEditor">
						<span class="mapping-placeholder">Child object</span>
					</ng-container>
					<ng-template #rowModeEditor>
					<dx-select-box [items]="cell.data.allowedModes" [(value)]="cell.data.mode" [elementAttr]="getModeSelectElementAttr(cell.data)" [disabled]="!canEditMapping(cell.data)" (onValueChanged)="onModeValueChanged(cell.data)" width="140">
					</dx-select-box>
					</ng-template>
				</div>
			</div>

			<div *dxTemplate="let cell of 'valueTemplate'">
				<ng-container *ngIf="isChildMappingRow(cell.data); else scalarValueTemplate">
					<div class="lookup-summary-card">
						<div class="lookup-summary-title">{{ cell.data.childMappingCount ? (cell.data.childMappingCount + ' child mapping' + (cell.data.childMappingCount === 1 ? '' : 's')) : 'No child mapping yet' }}</div>
						<dx-button text="Map child" type="normal" stylingMode="outlined" [elementAttr]="getChildMapButtonElementAttr(cell.data)" [disabled]="cell.data.readOnly" (onClick)="childMappingRequested.emit(cell.data)"></dx-button>
					</div>
				</ng-container>
				<ng-template #scalarValueTemplate>
				<ng-container [ngSwitch]="cell.data.mode">
					<div *ngSwitchCase="'SourceField'" class="editor-block">
						<div class="mapping-inline">
						<div class="source-dropdown-editor" [attr.data-cy]="'mapper-source-editor-' + cell.data.targetFieldId" [attr.data-source-tree-ready]="isSourceDropdownPrepared(cell.data)" (mouseenter)="prewarmSourceDropdown(cell.data)" (click)="$event.stopPropagation()" (mousedown)="onSourceDropdownPointerDown($event, cell.data)" (dblclick)="$event.stopPropagation()" (mapper-select-source-field)="selectSourceFieldFromEvent($event, cell.data)">
							<dx-drop-down-box [value]="cell.data.sourceFieldPath" [dataSource]="getSourceFieldOptionsForRow(cell.data)" [elementAttr]="getSourceDropDownElementAttr(cell.data)" valueExpr="path" displayExpr="label" placeholder="Choose source field" [(opened)]="sourceDropdownOpenedByRowId[cell.data.targetFieldId]"
								[showClearButton]="canEditMapping(cell.data) && !!cell.data.sourceFieldPath" [disabled]="!canEditMapping(cell.data)" [dropDownOptions]="sourceDropDownOptions" (onValueChanged)="onSourceFieldValueChanged($event, cell.data)" (onClosed)="onSourceDropdownClosed()">
								<div *dxTemplate="let data of 'content'">
									<div class="source-dropdown-content" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
										<div class="source-tree-search">
										<input class="grid-search" type="text" [attr.data-cy]="'mapper-source-search-' + cell.data.targetFieldId" [value]="getSourceFieldSearchValue(cell.data)" (input)="setSourceFieldSearchValue(cell.data, $any($event.target).value)" placeholder="Search source fields..." [disabled]="!canEditMapping(cell.data)" />
										</div>

										<div class="selected-source-field" *ngIf="cell.data.sourceFieldPath">
											Selected: <strong>{{ cell.data.sourceFieldPath }}</strong>
										</div>

										<div class="source-tree-body" (wheel)="$event.stopPropagation()">
											<dx-tree-view [items]="getCachedSourceTreeItems(cell.data)" dataStructure="tree" keyExpr="id" displayExpr="displayName" itemsExpr="items" hasItemsExpr="hasItems" [searchEnabled]="false" [expandEvent]="'click'" [selectByClick]="true" [focusStateEnabled]="false" [activeStateEnabled]="true"
												[disabled]="!canEditMapping(cell.data)" (onItemClick)="onSourceTreeItemClick($event, cell.data)" (onItemExpanded)="onSourceTreeItemExpanded($event)">
												<div *dxTemplate="let item of 'item'">
													<div class="source-tree-item" [attr.data-cy]="'mapper-source-option-' + cell.data.targetFieldId + '-' + item.path">
															<div class="source-tree-item-main">
																<div class="source-tree-item-copy">
										<span class="source-tree-item-name">{{ item.path || item.displayName }}</span>
										<span class="source-tree-item-path" *ngIf="item.path && item.displayName !== item.path">{{ item.displayName }}</span>
																</div>
															</div>

														<div class="source-tree-item-chips">
															<span class="source-tree-chip picklist" *ngIf="item.isPicklist">picklist</span>
																	<span class="source-tree-chip reference" *ngIf="item.isReference">reference</span>
																	<span class="source-tree-chip" *ngIf="item.deferredLoadState === 'loading'">loading...</span>
																	<button type="button" class="source-tree-chip" *ngIf="item.deferredLoadState === 'error'" [title]="item.deferredLoadError || 'Could not load nested fields'" (click)="retryDeferredSourceNode($event, item)">Retry</button>
															<span class="source-tree-chip udf" *ngIf="item.isUserDefinedField">UDF</span>
															<span class="source-tree-chip" *ngIf="item.isCollection">collection</span>
														</div>
													</div>
												</div>
											</dx-tree-view>
										</div>

										<div class="source-tree-actions" *ngIf="cell.data.sourceFieldPath && canEditMapping(cell.data)">
											<dx-button text="Clear selection" stylingMode="text" type="normal" (onClick)="clearSourceField(cell.data)">
											</dx-button>
										</div>
									</div>
								</div>
							</dx-drop-down-box>
							</div>

							<dx-button *ngIf="canOpenPicklistMap(cell.data)" text="Map" type="normal" stylingMode="outlined" [elementAttr]="getPicklistMapButtonElementAttr(cell.data)" [disabled]="cell.data.readOnly" (onClick)="picklistMapRequested.emit(cell.data)">
							</dx-button>
						</div>
					</div>

					<div *ngSwitchCase="'Constant'" class="editor-block" [attr.data-cy]="'mapper-constant-editor-' + cell.data.targetFieldId" (mapper-set-constant-value)="setConstantValueFromEvent($event, cell.data)">
						<dx-select-box *ngIf="cell.data.isPicklist" [dataSource]="getConstantPicklistOptions(cell.data)" displayExpr="label" valueExpr="value" [value]="cell.data.value" [searchEnabled]="true" [showClearButton]="true" placeholder="Select target option" [disabled]="cell.data.readOnly" [elementAttr]="getConstantValueElementAttr(cell.data)"
							[dropDownOptions]="constantPicklistDropDownOptions" (onValueChanged)="onConstantValueChanged($event, cell.data)">
						</dx-select-box>

						<dx-select-box *ngIf="isBooleanConstant(cell.data)" [dataSource]="booleanConstantOptions" displayExpr="label" valueExpr="value" [value]="cell.data.value" [searchEnabled]="false" [showClearButton]="true" placeholder="Select true or false" [disabled]="cell.data.readOnly" [elementAttr]="getConstantValueElementAttr(cell.data)"
							[dropDownOptions]="constantPicklistDropDownOptions" (onValueChanged)="onConstantValueChanged($event, cell.data)">
						</dx-select-box>

						<dx-text-box *ngIf="!cell.data.isPicklist && !isBooleanConstant(cell.data)" [value]="cell.data.value" valueChangeEvent="input" placeholder="Enter fixed value" [disabled]="cell.data.readOnly" [elementAttr]="getConstantValueElementAttr(cell.data)" (onValueChanged)="onConstantValueChanged($event, cell.data)">
						</dx-text-box>
					</div>

					<div *ngSwitchCase="'Expression'" class="editor-block">
						<div class="expression-cell">
							<div class="expression-preview" [title]="cell.data.value || ''">
								{{ cell.data.value || 'No expression set' }}
							</div>

							<dx-button text="Edit" type="normal" stylingMode="outlined" [elementAttr]="getExpressionEditButtonElementAttr(cell.data)" [disabled]="!canEditMapping(cell.data)" (onClick)="expressionEditRequested.emit(cell.data)">
							</dx-button>
						</div>
					</div>

					<div *ngSwitchCase="'Lookup'" class="lookup-summary-card">
						<div class="lookup-summary-title">{{ cell.data.referenceEntityName || cell.data.reference?.targetEntity || 'Lookup' }}</div>

						<dx-button text="Edit lookup" type="normal" stylingMode="outlined" [elementAttr]="getLookupEditButtonElementAttr(cell.data)" [disabled]="cell.data.readOnly" (onClick)="lookupEditRequested.emit(cell.data)">
						</dx-button>
					</div>

					<div *ngSwitchCase="'Ignore'" class="ignore-block">
						<div class="mapping-placeholder">No value</div>
					</div>
				</ng-container>

				<div class="normalization-panel" *ngIf="canConfigureNormalization(cell.data)" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
					<details [open]="isNormalizationExpanded(cell.data)" (toggle)="onNormalizationToggle(cell.data, $event)">
						<summary>{{ getNormalizationSummary(cell.data) }}</summary>
						<div class="normalization-options">
							<label class="normalization-check">
								<input type="checkbox" [checked]="isNormalizationFlagEnabled(cell.data, 'trimWhitespace')" [disabled]="cell.data.readOnly" (change)="setNormalizationFlag(cell.data, 'trimWhitespace', $any($event.target).checked)" />
								<span>Trim</span>
							</label>

							<label class="normalization-check">
								<input type="checkbox" [checked]="isNormalizationFlagEnabled(cell.data, 'emptyStringToNull')" [disabled]="cell.data.readOnly" (change)="setNormalizationFlag(cell.data, 'emptyStringToNull', $any($event.target).checked)" />
								<span>Empty to null</span>
							</label>

							<label class="normalization-check">
								<input type="checkbox" [checked]="isNormalizationFlagEnabled(cell.data, 'truncateToMaxLength')" [disabled]="cell.data.readOnly" (change)="setNormalizationFlag(cell.data, 'truncateToMaxLength', $any($event.target).checked)" />
								<span>Truncate</span>
							</label>

							<label class="normalization-field compact" [class.is-disabled]="cell.data.readOnly || !isNormalizationMaxLengthEnabled(cell.data)">
								<span>Max</span>
								<input type="number" min="1" [value]="getNormalizationMaxLength(cell.data) ?? ''" [placeholder]="cell.data.maxLength || ''" [disabled]="cell.data.readOnly || !isNormalizationMaxLengthEnabled(cell.data)" (input)="setNormalizationMaxLength(cell.data, $any($event.target).value)" />
							</label>

							<label class="normalization-field" [class.is-disabled]="cell.data.readOnly || !isNormalizationMaxLengthEnabled(cell.data)">
								<span>Truncate as</span>
								<input type="text" [value]="getNormalizationTruncateSuffix(cell.data)" placeholder="...." [disabled]="cell.data.readOnly || !isNormalizationMaxLengthEnabled(cell.data)" (input)="setNormalizationTruncateSuffix(cell.data, $any($event.target).value)" />
							</label>

							<label class="normalization-check">
								<input type="checkbox" [checked]="isNormalizationFlagEnabled(cell.data, 'padLeft')" [disabled]="cell.data.readOnly" (change)="setNormalizationFlag(cell.data, 'padLeft', $any($event.target).checked)" />
								<span>Pad left</span>
							</label>

							<label class="normalization-field compact" [class.is-disabled]="cell.data.readOnly || !isNormalizationPadLeftEnabled(cell.data)">
								<span>Pad to</span>
								<input type="number" min="1" [value]="getNormalizationPadLeftToLength(cell.data) ?? ''" [placeholder]="cell.data.maxLength || ''" [disabled]="cell.data.readOnly || !isNormalizationPadLeftEnabled(cell.data)" (input)="setNormalizationPadLeftToLength(cell.data, $any($event.target).value)" />
							</label>

							<label class="normalization-field compact" [class.is-disabled]="cell.data.readOnly || !isNormalizationPadLeftEnabled(cell.data)">
								<span>With</span>
								<input type="text" maxlength="1" [value]="getNormalizationPadLeftChar(cell.data)" placeholder="space" [disabled]="cell.data.readOnly || !isNormalizationPadLeftEnabled(cell.data)" (input)="setNormalizationPadLeftChar(cell.data, $any($event.target).value)" />
							</label>

							<label class="normalization-field">
								<span>Newlines</span>
								<select [value]="getNormalizationNewlineMode(cell.data)" [disabled]="cell.data.readOnly" (change)="setNormalizationNewlineMode(cell.data, $any($event.target).value)">
									<option *ngFor="let mode of normalizationNewlineModes" [value]="mode.value">{{ mode.label }}</option>
								</select>
							</label>

							<label class="normalization-field">
								<span>Number format</span>
								<input type="text" [value]="getNormalizationNumberFormat(cell.data)" placeholder="0.00" [disabled]="cell.data.readOnly" (input)="setNormalizationNumberFormat(cell.data, $any($event.target).value)" />
							</label>

							<label class="normalization-field">
								<span>Date format</span>
								<input type="text" [value]="getNormalizationDateFormat(cell.data)" placeholder="yyyy-MM-dd" [disabled]="cell.data.readOnly" (input)="setNormalizationDateFormat(cell.data, $any($event.target).value)" />
							</label>
						</div>
					</details>
				</div>
				</ng-template>
			</div>

			<div *dxTemplate="let cell of 'previewTemplate'">
				<div class="preview-cell" [attr.data-cy]="'mapper-row-preview-' + cell.data.targetFieldId" [class.is-loading]="cell.data.isResolving">
					<ng-container *ngIf="isChildMappingRow(cell.data)">
						<div class="preview-value">{{ cell.data.childMappingCount ? 'Mapped in object tab' : 'Open child mapper to configure' }}</div>
					</ng-container>
					<ng-container *ngIf="!isChildMappingRow(cell.data)">
					<ng-container *ngIf="cell.data.isResolving; else previewContent">
						<div class="preview-loading">
							<span class="spinner"></span>
							<span>Resolving source data...</span>
						</div>
					</ng-container>

					<ng-template #previewContent>
						<ng-container *ngIf="cell.data.isPicklist; else rawPreview">
							<div class="preview-value">
								{{ getTargetPicklistLabel(cell.data, cell.data.previewValue) || getPreviewDisplayValue(cell.data.previewValue) }}
							</div>
						</ng-container>

						<ng-template #rawPreview>
							<div class="preview-value" [class.has-visible-whitespace]="!!getPreviewWhitespaceSummary(cell.data.previewValue)" [title]="getPreviewDisplayValue(cell.data.previewValue)">
								{{ getPreviewVisibleValue(cell.data.previewValue) }}
							</div>
							<div class="preview-note" *ngIf="getPreviewWhitespaceSummary(cell.data.previewValue) as whitespaceSummary">{{ whitespaceSummary }}</div>
						</ng-template>
					</ng-template>
					</ng-container>
				</div>
			</div>

			<div *dxTemplate="let cell of 'statusTemplate'">
				<div class="status-cell" [attr.data-cy]="'mapper-row-status-' + cell.data.targetFieldId">
					<div class="status-loading" *ngIf="cell.data.isResolving">
						<span class="spinner"></span>
						<span>{{ cell.data.resolvingMessage || 'Refreshing preview...' }}</span>
					</div>

					<ng-container *ngIf="!cell.data.isResolving && getRowStatusLabel(cell.data) as statusLabel">
						<div class="status-pill ready" *ngIf="statusLabel === 'Ready'">Ready</div>
						<div class="status-pill ready" *ngIf="statusLabel === 'Mapped'" title="This field is mapped but has not been re-previewed yet.">Mapped</div>
						<div class="status-pill muted" *ngIf="statusLabel === 'Ignored'">Ignored</div>
						<div class="status-pill muted" *ngIf="statusLabel === 'Read-only'">Read-only</div>
						<div class="status-pill warning" *ngIf="statusLabel === 'Needs input'">Needs input</div>
						<div class="status-pill danger" [attr.title]="cell.data.validationMessage || null" *ngIf="statusLabel === 'Needs attention'">Issue</div>
					</ng-container>
				</div>
			</div>
		</dx-data-grid>
		</div>
	</div>
</div>
